import * as React from 'react';

const SvgFlexAlign = (props) => (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="flex-align-left">
      <path
        id="Solid"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.017 1.3335H4.23231C3.88089 1.33349 3.5777 1.33348 3.32799 1.35388C3.06443 1.37541 2.80228 1.42296 2.55003 1.55148C2.1737 1.74323 1.86774 2.04919 1.676 2.42552C1.54747 2.67777 1.49992 2.93992 1.47839 3.20348C1.45799 3.45319 1.458 3.75635 1.45801 4.10778V11.8925C1.458 12.2439 1.45799 12.5471 1.47839 12.7969C1.49992 13.0604 1.54747 13.3226 1.676 13.5748C1.86774 13.9511 2.1737 14.2571 2.55003 14.4488C2.80228 14.5774 3.06443 14.6249 3.32799 14.6465C3.5777 14.6669 3.88087 14.6668 4.2323 14.6668H12.0171C12.3685 14.6668 12.6717 14.6669 12.9214 14.6465C13.1849 14.6249 13.4471 14.5774 13.6993 14.4488C14.0756 14.2571 14.3816 13.9511 14.5734 13.5748C14.7019 13.3226 14.7494 13.0604 14.771 12.7969C14.7914 12.5471 14.7914 12.244 14.7913 11.8925V4.10779C14.7914 3.75636 14.7914 3.45319 14.771 3.20348C14.7494 2.93992 14.7019 2.67777 14.5734 2.42552C14.3816 2.04919 14.0756 1.74323 13.6993 1.55148C13.4471 1.42296 13.1849 1.37541 12.9214 1.35388C12.6717 1.33348 12.3685 1.33349 12.017 1.3335ZM9.12476 3.66683C9.12476 3.66683 4.8262 3.66683 4.45801 3.66683C4.08982 3.66683 3.79134 3.96531 3.79134 4.3335L3.79134 11.6668C3.79134 12.035 4.08982 12.3335 4.45801 12.3335C4.8262 12.3335 9.12476 12.3335 9.12476 12.3335V3.66683Z"
        fill="#384250"
      />
    </g>
  </svg>
);

export default SvgFlexAlign;
